import * as React from "react"
import {NavigationBar, Layout} from "./layout"
import Stack from 'react-bootstrap/Stack';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Typography } from "@mui/material";


function Publications () {
  let chanHandbookVol1= <Stack direction="horizontal" gap={4}>
  <div><img src={"/chanHandbook1.jpg"} /><br/>
  <Typography variant="body1">
  <a href="https://www.amazon.com/Chan-Handbook-Learners-Guide-Meditation/dp/1480053201/ref=sr_1_6?m=A1I40WMT1SR62H&s=merchant-items&ie=UTF8&qid=1474267410&sr=1-6">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a> <br/>
    </Typography></div>
  <Typography variant="body1">
  《禪修手冊：禪修初學指導》是了解坐禪的道理和技術必讀的一本參考書。本書中，永化禪師揭示了坐禪的深妙方法，從基本的拉伸和坐姿，到佛教的基本義理。作為一位修習嚴格的禪修技術20年的僧人，永化法師以一種平易近人的方式，把這些傳統的技能呈現給了西方。<br/><br/>
  《禪修手冊》可供普通讀者閱讀，但它也包含實用和具體的指導，對高級練習者具有重要價值。 此外，無論宗教信仰如何，所有人都可以從禪修中獲得個人利益。 因此，禪修手冊是送給任何對打坐感興趣的人的絕佳禮物。<br/><br/>
  禪是大乘佛教的一宗，由佛陀親傳，通過祖師一脈傳承至今。 在亞洲，幾千年來，坐禪的力量被傳授給尋求開悟的人。
  </Typography>
  </Stack>;

let chanHandbookVol2=<Stack direction="horizontal" gap={4}>
<div><img src={"/chanHandbook2.png"} /><br/>
<Typography variant="body1">
<a href="https://www.amazon.com/dp/B0BVYP96QD?psc=1&ref=ppx_pop_dt_b_asin_image">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a><br/>
  </Typography></div>
  <Typography variant="body1">
《禪修手冊第二卷：洞察》是了解坐禪的道理和技術必讀的一本參考書。本書中，永化禪師揭示了坐禪的深妙方法，從基本的拉伸和坐姿，到佛教的基本義理。作為一位修習嚴格的禪修技術20年的僧人，永化法師以一種平易近人的方式，把這些傳統的技能呈現給了西方。<br/><br/>
《禪修手冊》可供普通讀者閱讀，但它也包含實用和具體的指導，對高級練習者具有重要價值。 此外，無論宗教信仰如何，所有人都可以從禪修中獲得個人利益。 因此，禪修手冊是送給任何對打坐感興趣的人的絕佳禮物。<br/><br/>
禪是大乘佛教的一宗，由佛陀親傳，通過祖師一脈傳承至今。 在亞洲，幾千年來，坐禪的力量被傳授給尋求開悟的人。 <br/><br/>
“打坐是恢復身體、心理、情緒和心靈平衡的強大技術。 最終，打坐將幫助你開啟內在的智慧，終結痛苦並開悟。 從一個更基礎的層面上說，你將發展出更大的專注力，這種專注力將給你的生活立即帶來實際的應用。” ——永化禪師
</Typography>
</Stack>;

let purelandHandbookVol1=<Stack direction="horizontal" gap={4}>
<div><img src={"/purelandHandbook.jpg"} /><br/>
<Typography variant="body1">
<a href="https://www.amazon.com/Pure-Land-Handbook-Mahayana-Buddhist/dp/1502836769/ref=pd_sim_14_5?ie=UTF8&psc=1&refRID=XN0WC4CJSAPMZWYXY46Z">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a><br/>
  </Typography></div>
<Typography variant="body1">
淨土法門是亞洲最為流行的佛教形式，但在西方卻鮮為人知。 本書中，我們將淨土教導介紹給那些可能還不熟悉這一深奧修行的人，希望更多的人能夠從這些方法中受益。 此外，我們將對淨土的基本原理有新的闡釋，因此即使是那些從小接觸並修行淨土多年的人，也能學到鮮為人知的要點。 本書為您呈現真正的美國式淨土佛教。<br/><br/>
如果......會怎麼樣？如果你可以終結所有痛苦並享受永恆的幸福？ 如果你能獲得一種永久的完美幸福狀態，而沒有它的對立面——痛苦？ 如果你能打破輪迴，繼續你的心靈修行，不斷進步，永不退步，那會怎樣？ 如果你能在一個和平的世界裡修行，周圍的人都支持你，你也支持他們？ 如果你能清除那些使你無法到真實自我和所有其他人的真實自我的阻礙？如果你能證悟本性，成佛，實現幫助一切眾生成佛的願？<br/><br/>
這是佛陀對我們的承諾，如果我們修行我們的心地，種下強壯的種子，生根發芽。 尋求開悟是一場漫長而艱巨的心靈旅程，可能需要多生多世。 不過，有一條更短、更愉快的道路.......它叫做淨土。
</Typography>
</Stack>;

let medicineMasterSutra=<Stack direction="horizontal" gap={4}>
<div><img src={"/medicineMasterSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/Medicine_Master_Sutra.pdf"}>Download <PictureAsPdfIcon /></a>
  </Typography></div>
<Typography variant="body1">
釋迦摩尼佛教授了藥師佛法門。修習這個法門的人既可以往生藥師佛東方淨土，也可以往生阿彌陀佛西方淨土。此法門的鮮明特色是在它也幫助眾生應對此生正在面臨的問題。具體來說，藥師佛法門消災、增福、祛病、延壽。<br/><br/>
這個殊勝法門可以給九法界一切眾生帶來真正不可思議的利益，無論他們根性利鈍。如宣化上人所說，信者得救。
<br/><br/>
-Master YongHua
</Typography>
</Stack>;

let fourtyTwoSectionSutra=<Stack direction="horizontal" gap={4}>
<div><img src={"/42sectionssutra.png"} /><br/>
<Typography variant="body1">
<a href={"/42_Sections_Sutra.pdf"}>Download <PictureAsPdfIcon /></a>
  </Typography></div>
<Typography>
我剛接觸佛教的時候，這是我最喜歡的佛經之一，因為簡單易懂而且很實際。後來我越讀越體會到裡面的深意。<br/><br/>
26章：革囊眾穢。爾來何為。去。吾不用。<br/><br/>
28章：切莫信汝意，汝意不可信。慎勿與色會。色會即禍生。得阿羅漢已。乃可信汝意。<br/><br/>
42章：吾視王侯之位。如過隙塵。視金玉之寶。如瓦礫。視無上乘。如夢金帛。視佛道。如眼前華。視禪定。如須彌柱。視涅槃。如晝夕寤。<br/><br/>
-永化法師
</Typography>
</Stack>;

let BequeathedTeachingSutra=<Stack direction="horizontal" gap={4}>
<div><img src={"/BequeathedTeachingSutra.png"} /><br/>
<Typography variant="body1">
<a href={"/The_Bequeathed_Sutra.pdf"}>Download <PictureAsPdfIcon /></a>
  </Typography></div>
<Typography variant="body1">
《遺教經》記錄了佛陀入涅槃前對弟子的最後教導。 他花了 49 年的時間講經說法，在最後離開之前，佛陀強調了什麼？<br/><br/>
在這裡，佛陀給了我們修行佛法的要領。 這部經真是佛陀的修行手冊。

</Typography>
</Stack>;

let EarthStoreSutra=<Stack direction="horizontal" gap={4}>
<div><img src={"/EarthStoreSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/EarthStoreSutra.pdf"}>Download <PictureAsPdfIcon /></a>
  </Typography></div>
<Typography variant="body1">
在遙遠的前世，地藏菩薩發現他的母親死後墮入地獄。 在佛的幫助下，他救度了母親。 地藏王菩薩看到了地獄眾生難以置信的痛苦，於是發宏誓願：地獄不空誓不涅槃。他生生世世修菩薩道，救度最難度眾生。<br/><br/>
在這部佛經解釋裡，永化法師討論了大乘佛教的核心概念，包括佛陀對我們死後所發生的事的教導。

</Typography>
</Stack>;

let AmitabhaSutra=<Stack direction="horizontal" gap={4}>
<div><img src={"/AmitabhaSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/Amitabha_Sutra.pdf"}>Download <PictureAsPdfIcon /></a>
  </Typography></div>
<Typography variant="body1">
佛陀教導他的弟子們，有一位佛號阿彌陀，居住在遙遠的星系——西方極樂淨土。 佛陀教導說，在當今這個精神墮落的時代，我們證悟最大的希望就是往生阿彌陀佛國土，在那裡我們不會再體驗到任何痛苦，能夠在修行中進步，直到成佛。
<br/><br/>
永化法師對這部影響深遠的淨土宗典籍給出了鮮明的美國式詮釋。淨土宗是當今東亞最廣泛修行的佛教形式。 永化法師秉承了他解釋佛經的一貫風格，教給我們能夠應用於生活中的實用修行方法。
</Typography>
</Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
  chanHandbookVol1= <><div><img src={"/chanHandbook1.jpg"} /><br/>
  <Typography variant="body1">
  <a href="https://www.amazon.com/Chan-Handbook-Learners-Guide-Meditation/dp/1480053201/ref=sr_1_6?m=A1I40WMT1SR62H&s=merchant-items&ie=UTF8&qid=1474267410&sr=1-6">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a> <br/><br/>
    </Typography></div>
  <Typography variant="body1">
  《禪修手冊：禪修初學指導》是了解坐禪的道理和技術必讀的一本參考書。本書中，永化禪師揭示了坐禪的深妙方法，從基本的拉伸和坐姿，到佛教的基本義理。作為一位修習嚴格的禪修技術20年的僧人，永化法師以一種平易近人的方式，把這些傳統的技能呈現給了西方。<br/><br/>
  《禪修手冊》可供普通讀者閱讀，但它也包含實用和具體的指導，對高級練習者具有重要價值。 此外，無論宗教信仰如何，所有人都可以從禪修中獲得個人利益。 因此，禪修手冊是送給任何對打坐感興趣的人的絕佳禮物。<br/><br/>
  禪是大乘佛教的一宗，由佛陀親傳，通過祖師一脈傳承至今。 在亞洲，幾千年來，坐禪的力量被傳授給尋求開悟的人。
  </Typography></>;

  chanHandbookVol2=<><div><img src={"/chanHandbook2.png"} /><br/>
  <Typography variant="body1">
  <a href="https://www.amazon.com/dp/B0BVYP96QD?psc=1&ref=ppx_pop_dt_b_asin_image">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a><br/><br/>
    </Typography></div>
    <Typography variant="body1">
  《禪修手冊第二卷：洞察》是了解坐禪的道理和技術必讀的一本參考書。本書中，永化禪師揭示了坐禪的深妙方法，從基本的拉伸和坐姿，到佛教的基本義理。作為一位修習嚴格的禪修技術20年的僧人，永化法師以一種平易近人的方式，把這些傳統的技能呈現給了西方。<br/><br/>
  《禪修手冊》可供普通讀者閱讀，但它也包含實用和具體的指導，對高級練習者具有重要價值。 此外，無論宗教信仰如何，所有人都可以從禪修中獲得個人利益。 因此，禪修手冊是送給任何對打坐感興趣的人的絕佳禮物。<br/><br/>
  禪是大乘佛教的一宗，由佛陀親傳，通過祖師一脈傳承至今。 在亞洲，幾千年來，坐禪的力量被傳授給尋求開悟的人。 <br/><br/>
  “打坐是恢復身體、心理、情緒和心靈平衡的強大技術。 最終，打坐將幫助你開啟內在的智慧，終結痛苦並開悟。 從一個更基礎的層面上說，你將發展出更大的專注力，這種專注力將給你的生活立即帶來實際的應用。” ——永化禪師
  </Typography></>;

purelandHandbookVol1=<>
<div><img src={"/purelandHandbook.jpg"} /><br/>
<Typography variant="body1">
<a href="https://www.amazon.com/Pure-Land-Handbook-Mahayana-Buddhist/dp/1502836769/ref=pd_sim_14_5?ie=UTF8&psc=1&refRID=XN0WC4CJSAPMZWYXY46Z">從 <img src={"/Amazon_logo.svg"} width="64px" /> 購買</a><br/><br/>
  </Typography></div>
<Typography variant="body1">
淨土法門是亞洲最為流行的佛教形式，但在西方卻鮮為人知。 本書中，我們將淨土教導介紹給那些可能還不熟悉這一深奧修行的人，希望更多的人能夠從這些方法中受益。 此外，我們將對淨土的基本原理有新的闡釋，因此即使是那些從小接觸並修行淨土多年的人，也能學到鮮為人知的要點。 本書為您呈現真正的美國式淨土佛教。<br/><br/>
如果......會怎麼樣？如果你可以終結所有痛苦並享受永恆的幸福？ 如果你能獲得一種永久的完美幸福狀態，而沒有它的對立面——痛苦？ 如果你能打破輪迴，繼續你的心靈修行，不斷進步，永不退步，那會怎樣？ 如果你能在一個和平的世界裡修行，周圍的人都支持你，你也支持他們？ 如果你能清除那些使你無法到真實自我和所有其他人的真實自我的阻礙？如果你能證悟本性，成佛，實現幫助一切眾生成佛的願？<br/><br/>
這是佛陀對我們的承諾，如果我們修行我們的心地，種下強壯的種子，生根發芽。 尋求開悟是一場漫長而艱巨的心靈旅程，可能需要多生多世。 不過，有一條更短、更愉快的道路.......它叫做淨土。
</Typography>
</>;

medicineMasterSutra=<>
<div><img src={"/medicineMasterSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/Medicine_Master_Sutra.pdf"}>Download <PictureAsPdfIcon /></a><br/><br/>
  </Typography></div>
<Typography variant="body1">
釋迦摩尼佛教授了藥師佛法門。修習這個法門的人既可以往生藥師佛東方淨土，也可以往生阿彌陀佛西方淨土。此法門的鮮明特色是在它也幫助眾生應對此生正在面臨的問題。具體來說，藥師佛法門消災、增福、祛病、延壽。<br/><br/>
這個殊勝法門可以給九法界一切眾生帶來真正不可思議的利益，無論他們根性利鈍。如宣化上人所說，信者得救。
<br/><br/>
-Master YongHua
</Typography>
</>;

fourtyTwoSectionSutra=<>
<div><img src={"/42sectionssutra.png"} /><br/>
<Typography variant="body1">
<a href={"/42_Sections_Sutra.pdf"}>Download <PictureAsPdfIcon /></a><br/><br/>
  </Typography></div>
<Typography>
我剛接觸佛教的時候，這是我最喜歡的佛經之一，因為簡單易懂而且很實際。後來我越讀越體會到裡面的深意。<br/><br/>
26章：革囊眾穢。爾來何為。去。吾不用。<br/><br/>
28章：切莫信汝意，汝意不可信。慎勿與色會。色會即禍生。得阿羅漢已。乃可信汝意。<br/><br/>
42章：吾視王侯之位。如過隙塵。視金玉之寶。如瓦礫。視無上乘。如夢金帛。視佛道。如眼前華。視禪定。如須彌柱。視涅槃。如晝夕寤。<br/><br/>
-永化法師
</Typography>
</>

BequeathedTeachingSutra=<>
<div><img src={"/BequeathedTeachingSutra.png"} /><br/>
<Typography variant="body1">
<a href={"/The_Bequeathed_Sutra.pdf"}>Download <PictureAsPdfIcon /></a><br/><br/>
  </Typography></div>
<Typography variant="body1">
《遺教經》記錄了佛陀入涅槃前對弟子的最後教導。 他花了 49 年的時間講經說法，在最後離開之前，佛陀強調了什麼？<br/><br/>
在這裡，佛陀給了我們修行佛法的要領。 這部經真是佛陀的修行手冊。

</Typography>
</>;

EarthStoreSutra=<>
<div><img src={"/EarthStoreSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/EarthStoreSutra.pdf"}>Download <PictureAsPdfIcon /></a>
 <br/><br/> </Typography></div>
<Typography variant="body1">
在遙遠的前世，地藏菩薩發現他的母親死後墮入地獄。 在佛的幫助下，他救度了母親。 地藏王菩薩看到了地獄眾生難以置信的痛苦，於是發宏誓願：地獄不空誓不涅槃。他生生世世修菩薩道，救度最難度眾生。<br/><br/>
在這部佛經解釋裡，永化法師討論了大乘佛教的核心概念，包括佛陀對我們死後所發生的事的教導。

</Typography>
</>;

AmitabhaSutra=<>
<div><img src={"/AmitabhaSutra.jpg"} /><br/>
<Typography variant="body1">
<a href={"/Amitabha_Sutra.pdf"}>Download <PictureAsPdfIcon /></a>
<br/><br/>  </Typography></div>
<Typography variant="body1">
佛陀教導他的弟子們，有一位佛號阿彌陀，居住在遙遠的星系——西方極樂淨土。 佛陀教導說，在當今這個精神墮落的時代，我們證悟最大的希望就是往生阿彌陀佛國土，在那裡我們不會再體驗到任何痛苦，能夠在修行中進步，直到成佛。
<br/><br/>
永化法師對這部影響深遠的淨土宗典籍給出了鮮明的美國式詮釋。淨土宗是當今東亞最廣泛修行的佛教形式。 永化法師秉承了他解釋佛經的一貫風格，教給我們能夠應用於生活中的實用修行方法。
</Typography>
</>;
  }

  return (
    <><NavigationBar/>
      {/* Hero Image */}
<div style={{ display: "grid" }}>
      <img
        style={{
          gridArea: "1/1",
          // maxHeight: 600,
        }}
        layout="fullWidth"
        aspectRatio={3 / 1}
        alt=""
        src="/publicationBanner.jpg"
        quality="40"
        formats={["auto", "webp", "avif"]}/>
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
        }}
      >
      </div>
    </div>
    {/* Main Content */}
  <Layout>

<div>
<Typography variant="h3">《禪修手冊：禪修初學指導》</Typography>
{chanHandbookVol1}
</div><br/><br/>
<div>
<Typography variant="h3">《禪修手冊第二卷：洞察》</Typography><br/>
{chanHandbookVol2}
</div><br/><br/>
<div>
<Typography variant="h3">《淨土手冊：大乘佛教解生死》</Typography><br/>
{purelandHandbookVol1}
</div><br/><br/>
<div>
<Typography variant="h3">《藥師經》</Typography><br/>
{medicineMasterSutra}
<br/><br/>
</div>
<div>
<Typography variant="h3">四十二章經</Typography><br/>
{fourtyTwoSectionSutra}
<br/><br/>
</div>
<div>
<Typography variant="h3">《遺教經》</Typography><br/>
{BequeathedTeachingSutra}<br/><br/>
</div>
<div>
<Typography variant="h3">地藏經</Typography><br/>
{EarthStoreSutra}<br/><br/>
</div>
<div>
<Typography variant="h3">佛說阿彌陀經</Typography><br/>
{AmitabhaSutra}<br/>
</div>
  </Layout></>);
}

export default Publications
